﻿import React from "react";
import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { useUrlProvider } from "../useUrlProvider.ts";
import { useUserContext } from "../auth/userContextProvider/UserContextProvider.tsx";
import { isNullOrWhitespace } from "@common/stringOperations.ts";

export interface ISystemLinksProps {
    systems: Array<{ id: string; name: string }>;
    tab?: string;
    onClick?: () => void;
}

function SystemLinks(props: ISystemLinksProps) {
    const urlProvider = useUrlProvider();
    const { permissions } = useUserContext();

    if (permissions.systemPermissions.read) {
        return props.systems.map((x, i) => (
            <React.Fragment key={x.id}>
                <DotLegalLink
                    linkColor={"primary"}
                    bold
                    stopPropagation
                    to={`${urlProvider.getSystemOverviewUrl(x.id)}${!isNullOrWhitespace(props.tab) ? "?tab=" + props.tab : ""}`}
                >
                    {x.name}
                </DotLegalLink>
                {i !== props.systems.length - 1 && <span style={{ marginRight: "4px" }}>,</span>}
            </React.Fragment>
        ));
    }

    return props.systems.flatMap((system) => system.name).join(", ");
}

export default SystemLinks;
